module.exports = __webpack_public_path__ + "static/flexible-hours-a59987351e0a7cdbc75f7d384db7a683.svg";